/**
 * @name environment
 * @desc Environment variables as declared in the .env files (Vite: import.meta.env)
 * @type {{enoBackendBasePath: string, keycloakBasePath: string, keycloakAuthServerUrl: string, surveyJsLicenseKey: string, medium: string}}
 */
const environment = {
  medium: import.meta.env.MODE,
  enoBackendBasePath: import.meta.env.VITE_ENO_BACKEND_BASE_PATH,
  keycloakBasePath: import.meta.env.VITE_KEYCLOAK_BASE_PATH,
  surveyJsLicenseKey: import.meta.env.VITE_SURVEYJS_LICENSE_KEY,
};

export default environment;
